module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Kurt Vonnegut once dropped upon our species a maddeningly true statement: “We are what we pretend to be, so we must be careful about what we pretend to be.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" This is very hard to argue with. Vonnegut, again, knows the score. This is indeed the drill. The world runs on pretense. We play along with the norms laid down by others, strengthening their power as we go, borrowing their plausibility in a lifelong bid to feel more plausible to ourselves and others. If we keep at it, maybe we’ll finally feel too legit to quit, too credible to be denied, and, fingers crossed, worthy of a salaried position and a health-care plan. These are the exchanges that make our world turn. We become what we normalize, like it or not. But what if the norms according to which we lay down our lives as living sacrifices are unworthy of our best selves, our souls, or the possibility of real human thriving? What if they turn out to be wicked?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Into this very promising mess, Dru Johnson places before us the question of rituals. It turns out there’s no escape from them. Even if we get free of one, we’ve really only ritualed our way into . . . wait for it . . . another, hopefully less toxic ritual, bound by "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("new bonds in a different deployment of energies. Human reality is made of rites done rightly and wrongly, knowingly and automatically, consciously and unconsciously. Rites are nonoptional.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("What we do with our force of habit, Johnson argues, is what we do—and will have done—with our lives, the sum total of what we were up to. Getting our rites right is a very big deal—a life’s work, in fact. What are we playing along with and why? If we delay or ignore this question, we may succeed in gaining a world of affirmation according to someone else’s norms, but we risk forfeiting our soul, our "), _c('i', [_vm._v("animus")]), _vm._v(", that interior part that still hungers and thirsts for the righteousness of God. In these pages, Johnson shows us how to begin the work of analyzing our own rituals (Who or what prescribed them? Are they worthy?) in the hope of living an undivided life.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("This is an essential task in our radioactive days, days in which certain rituals seem almost designed to deaden our conscience, and rituals of deep attentiveness feel almost like a luxury our lives of high-tech haste can no longer afford. Most helpfully, Johnson wonders how it is that certain rituals become “dark and flimsy,” tending toward estrangement, denial, and weakened spirit, and how we might bring them into the light so that our daily activities can support deep discernment, moral seriousness, and joy. In this, Johnson joins Henry David Thoreau as a voice that admonishes us against playing along with whatever it takes to avoid conflict and get by. Thoreau described the way his own conscience sometimes succumbed to such peer pressure thusly: “The greater part of what my neighbors call good I believe in my soul to be bad, and if I repent of anything, it is very likely to be my good behavior. What demon possessed me that I behaved so well?”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We are, after all, what we abide. We emit what we admit. By inviting us to think through our own behaviors with deeper discernment "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("and a lively attentiveness to God’s righteousness, Johnson invites us to consider, as prophetic thinking always does, the question of authority. What do righteous rites look like? How might our perverse designations give way to more beautiful orderings of our own energy expenditure from day to day? In considering these absolutely essential questions, Dru Johnson is a guide of deep wit, lyrical self-deprecation, and relentless wisdom.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "RightSb3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVID")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". Kurt Vonnegut, introduction to "), _c('i', [_vm._v("Mother Night")]), _vm._v(" (New York: Dial Press, 2009), vi.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")]), _vm._v(". Henry David Thoreau, "), _c('i', [_vm._v("Walden and the Famous Essay on “Civil Disobedience”")]), _vm._v(" (New York: Signet, 1942), 12.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa59ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 72
// module chunks = 0